import { BoxProps, Column, Box, Row } from "@hightouch/htui";
import { usePulseStaggerAnimation } from "./utils";

/**
 * Loader animation for tables within charts.
 * Staggered pulse effect.
 */

type TableChartLoaderProps = BoxProps & {
  columns?: number;
  rows?: number;
};

const widths = ["120px", "55px", "65px", "67px", "50px"];

export const TableChartLoader = ({
  columns = 2,
  rows = 5,
  ...props
}: TableChartLoaderProps) => {
  const { className, scope } = usePulseStaggerAnimation();

  return (
    <Column ref={scope} w="100%" {...props}>
      {Array.from({ length: rows }).map((_, rowIndex) => (
        <TableRow
          key={`${rowIndex}`}
          className={className}
          index={rowIndex}
          width={widths[rowIndex % widths.length]}
          columns={columns}
        />
      ))}
    </Column>
  );
};

const opacityIncrement = 16;

function TableRow({
  className,
  index,
  width,
  columns,
}: Pick<BoxProps, "className" | "width"> & { index: number; columns: number }) {
  return (
    <Row
      align="center"
      justify="Space-between"
      gap={3}
      pos="relative"
      px={6}
      py={4.5}
      h="56px"
      w="100%"
      borderBottomWidth="hairline"
      borderBottomStyle="solid"
      borderColor="base.divider"
      opacity={`calc(100% - ${index} * ${opacityIncrement}%)`}
    >
      {Array.from({ length: columns }).map((_, index) => (
        <TableCell key={index} className={className} width={width} />
      ))}
    </Row>
  );
}

const TableCell = ({
  className,
  width,
}: Pick<BoxProps, "className" | "width">) => {
  return (
    <Box
      className={className}
      width={width}
      height={5}
      bg="gray.200"
      borderRadius="md"
    />
  );
};
